import ContentZone from 'components/ContentZone';

const TabContent = ({ tab }) => {
    return <ContentZone blocks={tab.content} />;
};

export default TabContent;
